import { NAME} from './constants';

export const allCurrentUsersRights = state => state[NAME].rights;
export const companyIdsWhereUserHasChangeRights = state => state[NAME].companyIdsWhereUserHasChangeRights;
export const currentuserupn = state => state[NAME].upn;
export const currentusercompany = state => state[NAME].idCompany;
